import { render } from "./Confetti.vue?vue&type=template&id=aeab65ee"
import script from "./Confetti.vue?vue&type=script&lang=js"
export * from "./Confetti.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__